import { apiResponseMiddleware } from "@/middleware/api-response";
import axios from "axios";
import toast from "react-hot-toast";

import { setToken } from ".";

interface SignInProps {
  credentials: {
    username: string;
    password: string;
    recaptchaToken?: string;
  };
  redirect?: string;
}

interface LoginResponse {
  userId: number;
  status: boolean;
}

const API_URL = import.meta.env.VITE_FORM_API_URL as string;
const API_ENDPOINT = "api/Authentication/Login";
const LOADING_TOAST_ID = "signin-loading"; // ID یکتا برای toast لودینگ

export const signIn = async ({ credentials, redirect = "/dashboard/" }: SignInProps) => {
  // نمایش toast لودینگ با ID مشخص
  const loadingToastId = toast.loading("درحال ورود...", { id: LOADING_TOAST_ID });
  
  try {
    const response = await axios.post(
      `${API_URL}/${API_ENDPOINT}/${credentials.username}`,
      {
        password: credentials.password,
        recaptchaToken: credentials.recaptchaToken || null
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    
    // پاک کردن toast لودینگ
    toast.dismiss(LOADING_TOAST_ID);
    
    console.log("Login response:", response.data);
    // پردازش پاسخ موفق
    setToken({
      accessToken: response.data.data.accessToken,
      refreshToken: response.data.data.refreshToken
    });
    
    toast.success("ورود موفقیت آمیز بود", {
      id: "api-middleware"
    });
    window.location.replace(redirect);
    
  } catch (error: any) {
    // پاک کردن toast لودینگ در صورت خطا
    toast.dismiss(LOADING_TOAST_ID);
    
    // نمایش پیام خطا
    toast.error(error.response?.data?.Message || "خطا در ورود", {
      id: "signin-error"
    });
    
    throw error;
  }
};